import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import GameComponent from "game/app/components/game/game-component";
import {Link} from "react-router-dom";
import assets from "game/app/assets";

class Finalize extends GameComponent {
    finalize = () => {
        this.props.sendInput(this.getInstanceId(), { type: 'finalize' });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        'event': 'round_2_finish'
        });
    };

    render() {
        let btnClass = 'btn btn-primary';

        let completed = this.getInstanceProperty('ROUND_2_COMPLETED');
        let completedLife = this.getInstanceProperty('ROUND_2_COMPLETED_LIFE');

        if (completed) {

            let chechtakyTotal = this.getInstanceProperty('ROUND_2_CHECHTAKY');
            let chechtakyTasks = this.getInstanceProperty('ROUND_2_CHECHTAKY_TASKS');
            let chechtakyAnswers = this.getInstanceProperty('ROUND_2_CHECHTAKY_ANSWERS');
            let chechtakyBankrupt = this.getInstanceProperty('ROUND_2_CHECHTAKY_BANKRUPT');
            let satisfactionTotal = this.getInstanceProperty('ROUND_2_SATISFACTION');
            let financialIndex = this.getInstanceProperty('ROUND_2_FINANCIAL_INDEX');

            return (
                <div className='container'>
                    <div className='row'>
                        <div className={this.mainContainerClass}>
                            <div className='separate-bottom text-center'>
                                <h1 className='page-title-minor separate-bottom'>Vyhodnocení 2. kola</h1>
                                <p>Obstáli jste v tvorbě rozpočtu? Nebo se vám naopak nedařilo? Podívejte se, jak si vedete.</p>
                            </div>

                            <div className='card separate-bottom' id='round-result'>
                                <div className='card-body text-center'>
                                    <div className='row'>
                                        <div className='col-lg-4'>
                                            <p><img src={assets.resources.chechtaky}/></p>
                                            <p className='label'>Chechtáky</p>
                                        </div>
                                        <div className='col-lg-4'>
                                            <table className='table text-left'>
                                                <tr><td>Ukončení kola:</td><td className='text-right'>{ this.numberWithSign(10) }</td></tr>
                                                <tr><td>Základní úkoly:</td><td className='text-right'>{ this.numberWithSign(chechtakyAnswers) }</td></tr>
                                                <tr><td>Kreativní úkoly:</td><td className='text-right'>{ this.numberWithSign(chechtakyTasks) }</td></tr>
                                                <tr><td>Bankrot:</td><td className='text-right'>{ this.numberWithSign(chechtakyBankrupt) }</td></tr>
                                            </table>
                                        </div>
                                        <div className='col-lg-4'>
                                            <span className='value'>{ this.numberWithSign(chechtakyTotal) }</span>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className='row'>
                                        <div className='col-lg-4'>
                                            <p><img src={assets.resources.satisfaction_small}/></p>
                                            <p className='label'>Spokojenost</p>
                                        </div>
                                        <div className='col-lg-4'/>
                                        <div className='col-lg-4 col-lg-push-4'>
                                            <span className='value'>{ this.numberWithSign(satisfactionTotal) }</span>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className='row'>
                                        <div className='col-lg-4'>
                                            <p><img src={assets.finindex}/></p>
                                            <p className='label'>Finanční index</p>
                                        </div>
                                        <div className='col-lg-4'/>
                                        <div className='col-lg-4'>
                                            <span className='value'>{ financialIndex.toFixed(2) }</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p className='text-center'>
                                <Link to={`/game/${this.getInstanceId()}/round-3`} className='btn btn-primary btn-block'>Pokračovat do třetího kola</Link>
                            </p>
                        </div>
                    </div>
                </div>
            )
        }

        let money_positive = this.getInstanceProperty('STATS_MONEY') > 0;

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1 className='text-center'>Ukončit kolo</h1>
                        <div className='text-center'>
                            <p>Pokud máte vše v tomto kole hotové, můžete ho ukončit a pustit se do dalšího. Po ukončení tohoto kola se již nebudete moci vrátit ani ke kreativním úkolům.</p>
                            { !money_positive && <p className='text-danger'><strong>Váš rozpočet je v minusu!</strong></p> }
                            { completedLife && money_positive && <button onClick={this.finalize} className={btnClass}>Ukončit kolo</button> }
                            { ( !completedLife || !money_positive) && <span className='btn btn-primary disabled'>Ukončit kolo</span> }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Finalize);
